<script setup lang="ts">
import type { PropType } from 'vue'
import type { THomeSectionCollection } from '~/layers/homepage/data/types'
import SliderCollections from '~/components/markup/SliderCollections.vue'
import type { NavigationOptions } from 'swiper/types'

defineProps({
  section: {
    type: Object as PropType<THomeSectionCollection>,
    required: true,
  },
})

const isOpened = ref(false)

const navigation: NavigationOptions = {
  nextEl: '.slider__button_next',
  prevEl: '.slider__button_prev',
}
</script>

<template>
  <div class="fixed-panel fixed-panel_txt-mobile" @click="isOpened = !isOpened">
    <p class="fixed-panel__title">Коллекция</p>
    <p class="fixed-panel__subtitle">{{ section.name }}</p>
  </div>
  <div :class="{ 'fixed-panel__menu_open': isOpened }" class="fixed-panel__menu">
    <div class="slider slider-collections mix-blend-multiply">
      <client-only>
        <swiper-container
          :navigation="navigation"
          :speed="800"
          class="swiper-container slider__collections"
          init
          slides-per-view="auto"
          watch-overflow
        >
          <swiper-slide class="slider-collections__good" v-for="item in section.items" :key="item.name">
            <nuxt-link :to="item.link" class="slider-collections__good-img">
              <URemotePicture :picture="item.picture" />
            </nuxt-link>

            <nuxt-link class="slider-collections__good-link" :to="item.link">{{ item.name }}</nuxt-link>
          </swiper-slide>
        </swiper-container>
      </client-only>
      <div class="slider__navigation">
        <button class="slider__button slider__button_prev" type="button">
          <svg-icon height="20" name="left-slider" width="20" />
        </button>
        <button class="slider__button slider__button_next" type="button">
          <svg-icon height="20" name="right-slider" width="20" />
        </button>
      </div>
    </div>
  </div>
</template>
